import { FrontendLoad } from '@trucksmarter/shared';
import { DallasTableDataCell } from '@ui/Dallas/Table/DallasTable';
import { DimensionsCellContent } from './DimensionsCell';
import { TrailerTypesCellContent } from './TrailerTypesCell';
import DallasStack from '@ui/Dallas/Stack/DallasStack';
import DallasDivider from '@ui/Dallas/Dividers/DallasDivider';

import styles from './EquipmentCompactCell.module.scss';

interface Props {
  className?: string;
  load: FrontendLoad;
}

export default function EquipmentCompactCell({ className, load }: Props) {
  return (
    <DallasTableDataCell className={className}>
      <DallasStack
        className={styles.stack}
        direction="row"
        gap="xs"
        alignVertical="center"
      >
        <TrailerTypesCellContent
          className={styles.trailerTypes}
          trailerTypes={load.equipment.trailerTypes}
          compact={true}
        />
        <DallasDivider orientation="vertical" />
        <div className={styles.dimensions}>
          <DimensionsCellContent load={load} compact={true} />
        </div>
      </DallasStack>
    </DallasTableDataCell>
  );
}
